<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.2929 4.29289C18.6834 3.90237 19.3164 3.90237 19.707 4.29289C20.0974 4.68342 20.0975 5.31646 19.707 5.70696L9.06047 16.3534C8.47472 16.9392 7.52516 16.9391 6.93938 16.3534L2.29289 11.707C1.90237 11.3164 1.90237 10.6834 2.29289 10.2929C2.68342 9.90237 3.31643 9.90237 3.70696 10.2929L7.99992 14.5859L18.2929 4.29289Z" fill="white"/>
    </svg>
</template>

<script>

export default {
  name: 'AcceptIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
